"use client";

import { MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalSupportHub() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const infoRows = [{
    label: "Location",
    value: "Bujanovac, Serbia"
  }, {
    label: "Operations",
    value: "Mon–Fri 8am–6pm, Sat 9am–2pm"
  }, {
    label: "Support",
    value: "+41 76 535 00 02"
  }, {
    label: "Email",
    value: "office@swisssolutionsgroup.com"
  }];
  return <section data-section-id="1504" id="global-support-hub" className="relative w-full bg-background border-t border-b border-border overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8 py-28 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={leftRef} data-index={0} className="lg:col-span-5 transition-all duration-[600ms] ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(14px)"
        }}>
            {}
            <div className="flex items-center gap-2 mb-8">
              <span className="font-mono text-[0.75rem] tracking-[0.18em] uppercase text-muted-foreground font-medium">
                §  note no. 01 — visit our facility
              </span>
            </div>

            {}
            <h2 className="font-default text-foreground mb-12" style={{
            fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            lineHeight: 1.04
          }}>
              Engineered for{" "}
              <span className="relative inline-block">
                <em className="italic font-default" style={{
                color: "var(--primary)"
              }}>
                  industrial
                </em>
                <svg className="absolute left-0 -bottom-1 w-full" height="10" viewBox="0 0 220 10" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M2 6 Q 30 2, 60 5 T 120 5 T 180 4 T 218 6" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                </svg>
              </span>{" "}
              excellence.
            </h2>

            {}
            <div className="mb-10">
              {infoRows.map((row, i) => <div key={i} data-index={i} className="grid grid-cols-[100px_1fr] sm:grid-cols-[140px_1fr] gap-4 py-5 border-b border-dashed border-border">
                  <span className="font-mono text-[0.75rem] tracking-[0.16em] uppercase text-muted-foreground font-medium pt-1">
                    {row.label}
                  </span>
                  <span className="font-default text-foreground" style={{
                fontSize: "1.25rem",
                lineHeight: 1.4,
                fontWeight: 500
              }}>
                    {row.value}
                  </span>
                </div>)}
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 font-default font-semibold text-[0.875rem] tracking-[0.04em] uppercase transition-all duration-240">
                <Link to="/ContactPage">
                  <MapPin className="size-4" />
                  Get Directions
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-lg bg-background border-[1.5px] border-foreground text-foreground hover:bg-foreground hover:text-background px-8 py-6 font-default font-semibold text-[0.875rem] tracking-[0.04em] uppercase transition-all duration-220">
                <Link to="tel:+41765350002">
                  <Phone className="size-4" />
                  Call Support
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} data-index={1} className="lg:col-span-7 relative transition-all duration-[600ms] ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(14px)",
          transitionDelay: "120ms"
        }}>
            {}
            <div className="absolute -top-8 -right-8 w-[60%] h-[60%] rounded-lg blur-3xl pointer-events-none" style={{
            background: "var(--primary)",
            opacity: 0.2
          }} aria-hidden="true" />
            <div className="absolute -bottom-12 -left-6 w-[50%] h-[50%] rounded-lg blur-3xl pointer-events-none" style={{
            background: "var(--secondary)",
            opacity: 0.15
          }} aria-hidden="true" />

            {}
            <div className="relative bg-card rounded-lg p-6 md:p-10" style={{
            border: "1px solid var(--border)"
          }}>
              {}
              <div className="relative aspect-[7/5] w-full rounded-lg overflow-hidden bg-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/swiss_solutions_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/swiss_solutions_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699139/img/swiss_solutions_facility.png-wvc-sizes" alt="Modern industrial facility showcasing high-quality construction materials and logistics infrastructure" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>

              {}
              <p className="font-mono text-[0.75rem] tracking-[0.04em] text-muted-foreground italic mt-5 text-center">
                 certified distribution center, bujanovac
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}